var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#F5CA88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 15.875C15.625 16.3672 15.2383 16.7188 14.7812 16.7188C14.2891 16.7188 13.9375 16.3672 13.9375 15.875C13.9375 13.4141 15.9414 11.375 18.4375 11.375H19.5273C22.0234 11.375 24.0273 13.4141 24.0273 15.875V16.0508C24.0273 17.457 23.3242 18.793 22.1641 19.5664L20.3359 20.7969C20.0195 21.0078 19.8438 21.3594 19.8438 21.7109V21.7812C19.8438 22.2734 19.457 22.625 19 22.625C18.5078 22.625 18.1562 22.2734 18.1562 21.7812V21.7109C18.1562 20.7969 18.6133 19.918 19.3867 19.3906L21.2148 18.1602C21.9531 17.7031 22.375 16.8945 22.375 16.0508V15.875C22.375 14.3281 21.1094 13.0625 19.5625 13.0625H18.4375C16.8555 13.0625 15.625 14.3281 15.625 15.875ZM19 27.125C18.3672 27.125 17.875 26.6328 17.875 26C17.875 25.4023 18.3672 24.875 19 24.875C19.5977 24.875 20.125 25.4023 20.125 26C20.125 26.6328 19.5977 27.125 19 27.125Z",
    fill: "#031621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.33afe5d7723165e011b245e1b7bcc00d.svg";
export { ForwardRef as ReactComponent };